const setLanguage = language => {
  return {
    type: 'SET_LANGUAGE',
    language
  }
}

const setSelectedRegionId = selectedRegionId => {
  return {
    type: 'SET_SELECTED_REGION_ID',
    selectedRegionId
  }
}

const setSelectedRegionCountryMeta = selectedRegionCountryMeta => {
  return {
    type: 'SET_SELECTED_REGION_COUNTRY_META',
    selectedRegionCountryMeta
  }
}

const setRegionsData = regionsData => {
  return {
    type: 'SET_REGIONS_DATA',
    regionsData
  }
}
const setCountriesData = countriesData => {
  return {
    type: 'SET_COUNTRIES_DATA',
    countriesData
  }
}
const setReferenceRegionsData = referenceRegionsData => {
  return {
    type: 'SET_REFERENCE_REGIONS_DATA',
    referenceRegionsData
  }
}
const setSameCountryRegionsData = sameCountryRegionsData => {
  return {
    type: 'SET_SAME_COUNTRY_REGIONS_DATA',
    sameCountryRegionsData
  }
}
const setIndicatorsData = indicatorsData => {
  return {
    type: 'SET_INDICATORS_DATA',
    indicatorsData
  }
}

const setIndicatorsLastUpdated = lastUpdated => {
  return {
    type: 'SET_INDICATORS_LAST_UPDATED',
    lastUpdated
  }
}

const manageAllFilter = checked => {
  return {
    type: 'MANAGE_ALL_FILTER',
    checked
  }
}

const manageReferenceFilter = checked => {
  return {
    type: 'MANAGE_REFERENCE_FILTER',
    checked
  }
}

const manageSameCountryFilter = checked => {
  return {
    type: 'MANAGE_SAME_COUNTRY_FILTER',
    checked
  }
}

const manageTypeAheadFilter = selected => {
  return {
    type: 'MANAGE_TYPE_AHEAD_FILTER',
    selected
  }
}

const manageEvolutionFilter = selected => {
  return {
    type: 'MANAGE_EVOLUTION_FILTER',
    selected
  }
}

const manageChartTypeFilter = selected => {
  return {
    type: 'MANAGE_CHART_TYPE_FILTER',
    selected
  }
}

const actions = {
  setLanguage,
  setSelectedRegionId,
  setSelectedRegionCountryMeta,
  setRegionsData,
  setCountriesData,
  setReferenceRegionsData,
  setSameCountryRegionsData,
  setIndicatorsData,
  setIndicatorsLastUpdated,
  manageAllFilter,
  manageReferenceFilter,
  manageSameCountryFilter,
  manageTypeAheadFilter,
  manageEvolutionFilter,
  manageChartTypeFilter
}

export default actions



// WEBPACK FOOTER //
// ./src/redux/actions.js